import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { AppResource } from 'src/app/app.resource';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { BreadcrumbComponent } from 'src/app/shared/components/breadcrumb/breadcrumb.component';
import { FooterComponent } from 'src/app/shared/components/footer/footer.component';
import { HeaderComponent } from 'src/app/shared/components/header/header.component';
import { ResumeStepComponent } from 'src/app/shared/components/resume-step/resume-step.component';
import { VyvApiClimaticComponent } from 'src/app/shared/components/vyv-api-climatic/vyv-api-climatic.component';
import { VyvSummaryComponent } from 'src/app/shared/components/vyv-summary/vyv-summary.component';
import { WebCallbackComponent } from 'src/app/shared/components/web-callback/web-callback.component';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  imports: [
    CommonModule,
    BreadcrumbComponent,
    FooterComponent,
    HeaderComponent,
    WebCallbackComponent,
    RouterModule,
    ResumeStepComponent,
    DialogModule,
    ButtonModule,
    VyvApiClimaticComponent,
    VyvSummaryComponent,
  ],
  standalone: true,
})
export class AppLayoutComponent extends BaseComponent implements OnInit {
  demo: boolean = false;

  constructor(resources: AppResource) {
    super(resources);
  }

  override ngOnInit() {}
}
